export enum BackgroundTaskType {
    ResyncPim,
    ResyncIdentity
}

export enum BackgroundTaskStatus {
    Completed = "Completed",
    Created = "Created",
    Running = "Running",
    Failed = "Failed",
    Cancelled = "Cancelled"
}

export class BackgroundTask {
    id: string;
    type: BackgroundTaskType;
    status: BackgroundTaskStatus;
}